import { Head } from "@inertiajs/react"
import { AppShell } from "@/components/AppShell"
import { PageHeader } from "@/components/PageHeader"
import { ProjectForm, type CustomerOption } from "@/components/projects/ProjectForm"

export default function ProjectsNew({ customers }: { customers: CustomerOption[] }) {
  return (
    <>
      <Head title="New project">
        <meta
          name="description"
          content="Create a project for a builder, custom builder, or homeowner — or as a standalone one-off."
        />
        <meta property="og:title" content="New project" />
        <meta
          property="og:description"
          content="Create a project for a builder, custom builder, or homeowner — or as a standalone one-off."
        />
      </Head>
      <AppShell>
        <PageHeader
          title="New project"
          description="Pick the customer — or create them right here."
        />
        <div className="mt-8">
          <ProjectForm
            customers={customers}
            action="/projects"
            method="post"
            submitLabel="Create project"
          />
        </div>
      </AppShell>
    </>
  )
}
